import { combineReducers } from 'redux';
import { priceCalendarFilterReducer } from './filter/priceCalendarFilterSlice';
import { priceCalendarMonthlyReducer } from './monthly/priceCalendarMonthlySlice';

export const combinedPriceCalendarReducers = combineReducers({
  filters: priceCalendarFilterReducer,
  monthly: priceCalendarMonthlyReducer
});
